// extracted by mini-css-extract-plugin
export default {"cellDetails":"_3lwtHMJ-gdlTyg_RPjf6d_","cellPhoto":"_22Pn1bYfH0xXmjEtJ-jdSP","photo":"_2_u82PZGuIVjZCCV0jVyl5","grid":"_79YyXKs5oPnqnkYHZP49y"};